<template>
<div>
      <template>
        <v-btn
          @click.stop = "dialog=true"
          color="mygreen"
          dark
          >
            <img class="img" src="/img/icon_search.svg" style="margin-left: -6px;margin-right:6px;height:22px;" />
          患者検索</v-btn>
      </template>

    <v-dialog
      v-model="dialog"
      max-width="600px"
    >



      <v-card class="rounded-lg">
        <v-toolbar
          class="mb-9 text-center"
          color="mygreen"
          dark><span class="text-center">患者検索</span></v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col class="text-left" cols="3">診察券番号</v-col>
              <v-col cols="9" >
                <v-text-field outlined
                  v-model="bangou"
                  hint="数字6桁を入力してください."
                ></v-text-field>
              </v-col>


              <v-col class="text-left" cols="3">患者名(漢字)</v-col>
              <v-col cols="9" >
                  <v-row>
                  <v-col cols="6" >
                    <v-text-field outlined
                    @keyup.enter="search()"
                    v-model="sei"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" >
                    <v-text-field outlined
                    @keyup.enter="search()"
                    v-model="mei"
                    ></v-text-field>
                  </v-col>
                  </v-row>
              </v-col>


              <v-col class="text-left" cols="3">患者名(カナ)</v-col>
              <v-col cols="9" >
                  <v-row>
                      <v-col cols="6" >
                        <v-text-field outlined
                        @keyup.enter="search()"
                        v-model="sei_kana"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6" >
                        <v-text-field outlined
                        @keyup.enter="search()"
                        v-model="mei_kana"
                        ></v-text-field>
                      </v-col>
                  </v-row>
              </v-col>



              <v-col class="text-left" cols="3">固定電話番号</v-col>
              <v-col cols="9" >
                <v-text-field outlined
                    @keyup.enter="search()"
                    v-model="tel"
                ></v-text-field>
              </v-col>


              <v-col class="text-left" cols="3">携帯電話番号</v-col>
              <v-col cols="9" >
                <v-text-field outlined
                    @keyup.enter="search()"
                    v-model="phone"
                ></v-text-field>
              </v-col>


              <v-col class="text-left" cols="3">最終来院日</v-col>
              <v-col cols="9" >
                  <v-row>
                      <v-col cols="5.5" >
                        <v-menu
                            v-model="menu_from"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                @keyup.enter="search()"
                                v-model="from"
                                append-icon="mdi-calendar-month"
                                outlined
                                v-bind="attrs"
                                v-on="on"></v-text-field>
                            </template>
                            <v-date-picker 
                            v-model="from" 
                            @input="menu_from = false"
                            color="mygreen"
                            :no-title="true"
                            locale="jp-ja"
                            :day-format="date => new Date(date).getDate()"
                            ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="1" >～</v-col>

                      <v-col cols="5.5" >
                        <v-menu
                            v-model="menu_to"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                @keyup.enter="search()"
                                v-model="to"
                                append-icon="mdi-calendar-month"
                                outlined
                                v-bind="attrs"
                                v-on="on"></v-text-field>
                            </template>
                            <v-date-picker 
                            v-model="to" @input="menu_to = false"
                            color="mygreen"
                            :no-title="true"
                            locale="jp-ja"
                            :day-format="date => new Date(date).getDate()"
                            ></v-date-picker>
                        </v-menu>
                      </v-col>
                  </v-row>
              </v-col>

            </v-row>

          </v-container>
        </v-card-text>

        <v-card-actions class="pb-6">
          <v-spacer></v-spacer>
          <v-btn
            color="white"
            @click="dialog = false">戻る</v-btn>
          <v-btn dark
            color="light-green darken-1"
            @click="search()">検索</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</div>
</template>


<script>
// @ is an alias to /src
/* eslint-disable */
import mycolor from '@/mycolor.js';
/* eslint-disable */


export default {
    props: {
      isSameroute: Boolean,
    },

    created() {
        console.log('%c created: DialogPatientSearchMail.vue', mycolor.created);
    },

    data() {  //datas
            return {
                dialog: false,
                menu_from: '',
                menu_to: '',

                bangou: '',
                mei: '',
                mei_kana: '',
                sei: '',
                sei_kana: '',
                tel: '',
                phone: '',
                from: '',
                to: '',

            }
    },
    methods: {
        search(){
            console.log('患者検索開始');


            let data = {
                bangou: this.bangou,
                mei: this.mei,
                mei_kana: this.mei_kana,
                sei: this.sei,
                sei_kana: this.sei_kana,
                tel: this.tel,
                phone: this.phone,
                myfrom: this.from,
                myto: this.to,
            };


              if(this.isSameroute){
                  this.$emit("search", data);
              }else{
                  this.$router.push({
                    name: "patientlist_search_mail",
                    params: { data }
                  }).catch(()=>{});
              }

            this.dialog = false;

        }  // search()
    }, // methods
}
</script>

<style scoped>
/deep/ .v-input__append-inner{
    margin: auto !important;
}
/deep/ .row > div {
    height: 70px;
}
/deep/ .v-list-item__content{
    text-align: left;
}
/deep/ .theme--light.v-input{
    margin-top: -8px;
}
/deep/ .v-select__slot{
    height: 40px;
}
/deep/ .v-dialog > .v-card > .v-card__text{
    padding-bottom: 0px;
}
</style>
